import { isValidObject } from '@airtel/air-design-system';
import { DOT_SYMBOL } from '../../constants/constants';
export var validateInput = function validateInput(formData, value) {
  if (value === void 0) {
    value = '';
  }
  var state = formData.state,
    showLoader = formData.showLoader,
    validationRegex = formData.validationRegex;
  var isError = state === 'error';
  var isValid = !isError && !showLoader;
  if (typeof validationRegex === 'string') {
    var isValidRegex = new RegExp(validationRegex).test(value);
    isValid = isValid && isValidRegex;
  }
  return isValid;
};
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (addressDetails, subHeading) => {
  if (subHeading) {
    return subHeading;
  }
  if (!isValidObject(addressDetails)) return '';
  var concatenatedValues = Object.values(addressDetails).reduce((subHeading, inputProps) => {
    var value = inputProps === null || inputProps === void 0 ? void 0 : inputProps.value;
    if (!subHeading) return value;
    if (value) {
      subHeading = subHeading + " " + DOT_SYMBOL + " " + value;
    }
    return subHeading;
  }, '');
  return concatenatedValues;
};
export var initializeFormState = inputProps => {
  var formState = {
    inputValues: {},
    validationMetrics: {}
  };
  if (!isValidObject(inputProps)) return {};
  Object.keys(inputProps).forEach(key => {
    formState.inputValues[key] = '';
    formState.validationMetrics[key] = false;
  });
  return formState;
};
export var getValuesFromAddressDetails = addressDetails => {
  return Object.entries(addressDetails).reduce((values, _ref) => {
    var key = _ref[0],
      inputProps = _ref[1];
    values[key] = (inputProps === null || inputProps === void 0 ? void 0 : inputProps.value) || '';
    return values;
  }, {});
};